function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.812 12.661a2.849 2.849 0 1 0 0-5.697 2.849 2.849 0 0 0 0 5.697",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.443 3.209A10.28 10.28 0 0 0 9.993 0 10.005 10.005 0 0 0 0 9.993c0 6.354 7.746 14.696 9.994 14.696 1.9 0 9.622-8.372 9.992-14.64a9.13 9.13 0 0 0-2.543-6.84M9.813 14.56a4.748 4.748 0 1 1 0-9.496 4.748 4.748 0 0 1 0 9.497M3.482 25.323a.95.95 0 1 0 0 1.899h12.661a.95.95 0 1 0 0-1.9z",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddress);
export default __webpack_public_path__ + "static/media/ic_address.d912a387a4f02f4a2c1625feaef59cde.svg";
export { ForwardRef as ReactComponent };